const initialStatus = {
  content: {},
  status: {
    get_script: {},
  },
  expanded: {},
  description: {},
}

const scriptReducer = (state = initialStatus, action) => {
  switch (action.type) {
    case 'RESET_SCRIPT_OBJ':
      return {}
    case 'RESET_SCRIPT_STATUS':
      return {
        ...state,
        status: {
          ...state.status,
          [action.payload]: {},
        },
      }
    case 'GET_SCRIPT_ERROR':
      return {
        ...state,
        status: {
          ...state?.status,
          get_script: {
            ...state?.status?.get_script,
            [action.payload.skillId]: {
              loading: false,
              success: false,
              error: action?.payload?.error || true,
            },
          },
        },
      }
    case 'GET_SCRIPT':
      return {
        ...state,
        status: {
          get_script: {
            ...state?.status?.get_script,
            [action?.payload?.skillId]: {
              loading: true,
              error: false,
              success: false,
            },
          },
        },
      }
    case 'SET_SCRIPT':
      return {
        ...state,
        content: {
          ...state?.content,
          [action?.payload?.skillId]: action?.payload?.data,
        },
        status: {
          get_script: {
            ...state?.status?.get_script,
            [action?.payload?.skillId]: {
              loading: false,
              error: false,
              success: true,
            },
          },
        },
      }
    case 'UPDATE_SCRIPT':
      return {
        ...state,
        status: {
          update_script: {
            ...initialStatus,
            loading: true,
            data: { ...action.payload },
          },
        },
      }
    case 'UPDATED_SCRIPT':
      return {
        ...state,
        status: {
          update_script: {
            ...initialStatus,
            success: true,
            message: action?.payload?.message,
          },
        },
      }

    case 'SET_FILE':
      return {
        ...state,
        file: action?.payload,
      }

    case 'SET_SCRIPT_EXPANDED':
      return {
        ...state,
        expanded: {
          ...state?.expanded,
          [action?.payload?.id]: {
            ...state?.expanded?.[action?.payload?.id],
            [action?.payload?.category]: action?.payload?.expanded,
          },
        },
      }

    case 'SET_SCRIPT_DESCRIPTION':
      return {
        ...state,
        description: {
          ...state?.description,
          [action?.payload?.id]: action?.payload?.description,
        },
      }

    default:
      return state
  }
}

export default scriptReducer
